import fieldworkPeriodDateHelper from '../Helpers/fieldworkPeriodDateHelper';

export default class PlanningItemMultiEditItem {
  PricingIds: number[];
  Countries: string;
  TimeSpan: string;
  Periods: { apply: boolean; startDate: Date; endDate: Date }[];
  CountryPlans: {
    pricingId: number;
    country: string;
    numberOfPlannedAssignments: number;
    applyTargetRate: boolean;
    targetAssignmentRate: number[];
    targetCompletionRate: number[];
  }[];

  constructor(selectedCountries, numberOfPlanningDetails, fetchedDates) {
    const countries = selectedCountries ?? [];
    this.PricingIds = countries.map((country) => country.pricingId);
    this.Countries = countries.map((country) => country.country).join(', ');
    const periodCount =
      typeof numberOfPlanningDetails === 'undefined' || numberOfPlanningDetails < 1 ? 1 : numberOfPlanningDetails;
    this.TimeSpan = fieldworkPeriodDateHelper.getTimeSpanForPeriodCount(periodCount);
    this.Periods = fieldworkPeriodDateHelper.generateDefaultPeriods(periodCount, fetchedDates);
    this.CountryPlans = countries.map((country) => ({
      pricingId: country.pricingId,
      country: country.country,
      numberOfPlannedAssignments:
        country.numberOfPlannedAssignments > 0
          ? country.numberOfPlannedAssignments
          : country.numberOfContractedAssignments,
      applyTargetRate: false,
      targetAssignmentRate: [30, 45, 25, 0],
      targetCompletionRate: [20, 30, 30, 20],
    }));
  }
}
